import React from 'react';
import { Checkbox } from './checkbox';

interface CheckButtonProps {
  value: string;
  label: string;
  description?: string;
  name: string;
  checked?: boolean;
  onClick?: () => void;
  color?: string;
  disabled?: boolean;
}

export const CheckButton: React.FC<CheckButtonProps> = ({
  value,
  label,
  description,
  name,
  checked,
  onClick,
  color = 'brandgreen',
  disabled = false,
}) => {
  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      className={`tw:flex tw:items-start tw:sm:items-center tw:shadow-sm tw:justify-center tw:bg-white tw:dark:bg-white/5 tw:p-2 tw:rounded-lg tw:border-zinc-200 tw:dark:border-zinc-700 tw:border tw:w-full focus:tw:outline-none focus:tw:ring-2 focus:tw:ring-brand-green-0 focus:tw:ring-offset-2 ${
        disabled
          ? `tw:!cursor-not-allowed tw:opacity-90 ${checked ? 'tw:border-brand-green-1/20 tw:bg-brand-green-1/5 tw:dark:border-brand-green-1/20 tw:dark:bg-brand-green-1/5' : ''}`
          : 'tw:cursor-pointer'
      }`}
    >
      <div className="tw:flex tw:flex-row tw:justify-flex-start tw:items-start tw:sm:items-center tw:sm:justify-center tw:w-full tw:gap-x-2 tw:gap-y-1 tw:sm:gap-y-0">
        <div className="tw:flex tw:items-center tw:justify-end tw:my-auto tw:sm:my-0 tw:sm:ml-2">
          <Checkbox
            color={color as any}
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            tabIndex={-1}
          />
        </div>
        <div className="tw:flex tw:flex-col tw:justify-center tw:sm:flex-row tw:sm:items-center tw:sm:gap-x-2">
          <span className="tw:block tw:text-sm tw:font-semibold tw:text-zinc-950 tw:dark:text-white">
            {label}
          </span>
          {description && (
            <div className="tw:text-xs tw:sm:text-sm tw:text-zinc-500 tw:dark:text-zinc-300 tw:sm:ml-1 tw:sm:inline-block">
              {description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
